export enum COLORS {
  WHITE_DARK = '#FAFAFA',
  GREEN = '#99CC33',
  BLUE = '#67B6F0',
  RED = '#C3454C',
  RED_ERROR = '#FA1313',
  AMBAR = '#D98A00',
  VIOLET = '#5A4B92',
  GRAY_TEXT = '#848482',
  BLACK = '#333',
  BLACK_BOLD = '#222',
  YELLOW = '#FFF2BF',
  YELLOW_DARK = '#B9A865',
  YELLOW_GENERIC = '#FFCC00',
  GRAY_PLACEHOLDER = '#BBB',
  GRAY_LIGHT = '#EEE',
  GRAY = '#DDD',
  GRAY_DARK = '#999',
  YELLOW_HIGHLIGHT = '#FFFF00'
}
